window.onload = function () {
    
};


// WEBPACK FOOTER //
// ./src/assets/js/app.js